<template>
    <div class="rhythmClass">
        <el-col :span="24" class="zhiAudio" align="left" v-if="heart.questionDto.detailInfo.audioUrl">
            <audio-style 
                style="width:180px;float:left"
                ref="audioRef"
                @startPlaying="startPlaying"
                @endPlaying="endPlaying"
                @getPlays="getPlays"
                :styleText="'请点击播放'"
                :audioUrl="heart.questionDto.detailInfo.audioUrl"
                class="audioCom"
            ></audio-style>
            <div class="playNum" v-if="heart.audioPlayTime!=-1">
                <div class="playNumIng"><img src="./../../../static/images/play.png" alt="" srcset=""></div>
                {{`X${plays}`}}
            </div>
        </el-col>
        <el-col :span="24" class="explainText" v-if="heart.questionDto.detailInfo.audioUrl">
            点击音频部分播放视唱
        </el-col>
        <el-col :span="24" class="imgStyle" align="left" :style="{height:heart.questionDto.detailInfo.audioUrl? 'calc( 100% - 55px )':''}">
            <div class="quImg fl" v-if="heart.questionDto.detailInfo.questionImgUrl">
                <img :src="heart.questionDto.detailInfo.questionImgUrl" v-viewer alt="" srcset="">
            </div>
            <div :class="['playTheDrums',heart.questionDto.detailInfo.questionImgUrl? 'fr':'marginAuto']">
                <div class="operationBox" v-show="recordingType == 'end'" style="left:12%;right:12%" v-loading="sdudent">
                    <audio-style 
                        style="width:45%;float:right"
                        ref="audioRecording"
                        v-if="luYingUrl"
                        @startPlaying="startPlayingLuYing"
                        @endPlaying="endPlayingLuYing"
                        @getPlays="getPlaysLuYing"
                        :audioUrl="luYingUrl"
                        class="audioCom"
                    ></audio-style>
                    <el-button size="mini" class="operationEnd" @click="againRecording(submitNum,heart.submitNum)" ref="operationGo" icon="el-icon-service">重新录制</el-button>
                </div>
                <div class="operationBox" v-show="recordingType == 'ing'">
                    <el-button class="operationIng" ref="operationIng" @click="endRecording">{{`停止录制(${timeLz}s)`}}</el-button>
                </div>
                <div class="operationBox" v-show="recordingType == 'go'">
                    <el-button class="operationGo" ref="operationGo" @click="goRecording" icon="el-icon-service">开始录制</el-button>
                </div>
                <p>开启录制后,自动播放音频</br>剩余录制次数：{{submitNum==-1? '不限次':submitNum}}</p>
            </div>
        </el-col>

        <audio ref="tock" :src="tockUrl" v-show="false"></audio>
    </div>
</template>
<script>
import recording from '../../lib/recording'
import audioStyle from '../../components/audioStyle'
import os from '../../lib/oss'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"rhythmChoice",
        props: {
            sonData: Object,
            allAnswer: Object,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                tockUrl:require('../../../static/music/tock.wav'),
                rhythmBeatVal:[],
                letTime:0,
                sdudent:false,
                timeHer:'',
                recordingType:'go',
                luYingUrl:'',
                timeLz:0,
                interval: '',
                plays:0,
                submitNum:0,
                score:'',//得分
                detailJsonVal:'',//得分细节 json
                playType:'click',
                answerType:null,
            }
        },
        components:{
            audioStyle
        },
        watch: {
            'luYingUrl':function(now,old){
                let that = this
                if(now&&that.answerType)that.answerType = null
                let pName = that.$route.query.paperName
                if((pName=="音乐测评"||pName=="中央美术学院中国画专业专业创作"||pName=="央美中国画专业专业创作")&&now){
                    that.getAjaxScore(now,()=>{
                        that.$emit('storeLocally')
                    })
                }else{
                    that.$emit('storeLocally')
                }
            },
            'plays':function(now,old){
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
            'submitNum':function(now,old){
                this.$emit('storeLocally')
            },
        },
        computed:{},
        created(){},
        mounted(){
            this.heart = this.sonData
            this.plays = utils.mottoClone(this.heart.audioPlayTime)
            this.submitNum = utils.mottoClone(this.heart.submitNum)
            this.$nextTick(function(){
                // 赋值答案
                if(this.allAnswer)
                this.answerType = this.allAnswer.obj.answerType
                if(this.allAnswer&&this.allAnswer.obj.rhythmSingAudioUrl){
                    this.luYingUrl = this.allAnswer.obj.rhythmSingAudioUrl
                    this.recordingType = 'end'
                    this.plays = this.allAnswer.playss
                    this.submitNum = this.allAnswer.submitNum
                }else{
                    this.rhythmBeatVal = []
                }
            })
        },
        methods:{
            goRecording(){
                if(this.$refs.audioRef&&this.$refs.audioRef.judgePaying()){
                    this.mouseStart(this.submitNum,this.heart.submitNum)
                }else{
                    this.endPlaying()
                    let that = this
                    setTimeout(function(){
                        that.mouseStart(that.submitNum,that.heart.submitNum)
                    },300)
                }
            },
            endRecording(){
                this.$refs.audioRef && this.$refs.audioRef.endAudio()
                this.recordingType = 'end'
                this.mouseEnd()
            },
            againRecording(plays,nPlays=-1){
                if(plays>0||nPlays==-1){
                    this.luYingUrl = ''
                    this.recordingType = 'ing'
                    if(this.$refs.audioRef && this.$refs.audioRef.judgePaying()){
                        this.mouseStart()
                    }else{
                        this.endPlaying()
                        let that = this
                        setTimeout(function(){
                            that.mouseStart()
                        },300)
                    }
                }else{
                    this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                }
            },
            mouseStart (plays,nPlays=-1) {
                if(plays>0||nPlays==-1){
                    this.clearTimer()
                    this.startTime = new Date().getTime()
                    this.timeLz = 0
                    recording.get((rec) => {
                        // 要获取浏览器的麦克风权限
                        if (rec) {
                            this.playType = 'do'
                            if (this.flag) {
                                this.mouseEnd()
                                this.flag = false
                            } else {
                                this.startAudio()
                                this.recordingType = 'ing'
                                this.recorder = rec
                                this.interval = setInterval(() => {
                                    this.timeLz++
                                    this.recorder.start()
                                }, 1000)
                            }
                        }else{
                            this.$message({showClose: true,message: '请设置您的麦克风访问权限'});
                        }
                    })
                }else{
                    this.$message({showClose: true,message: `该音频只能播放${nPlays}次`})
                }
            },
            mouseEnd () {
                let that = this
                that.clearTimer()
                that.endTime = new Date().getTime()
                if (that.recorder) {
                    that.recorder.stop()
                    let bold = that.recorder.getBlob()
                    let files = new File([bold], `recording${Date.parse(new Date())}.wav`, {type: 'audio/wav', lastModified: Date.now()})
                    os.uploadHttp(files,function(e,file){
                        that.sdudent = false
                        console.log(e)
                        that.luYingUrl = e

                        that.$nextTick(()=>{
                            wsMethod.wsSend210(that.heart.bId,that.heart.questionId,{
                                allData:this.$parent.allData,
                                uuid1:this.$parent.uuid1,
                                firstStartDateVal:this.$parent.firstStartDateVal,
                            })
                        })
                    })
                }
            },
            clearTimer () {
                if (this.interval) {
                    this.timeLz = 0
                    clearInterval(this.interval)
                }
            },
            getPlays(){
                if(this.$refs.audioRecording)
                this.$refs.audioRecording.endAudio();
                this.$refs.audioRef.fatherPlay(this.plays,this.heart.audioPlayTime)
            },
            startPlaying(){
                this.letTime = 0;
                this.timeHer = setInterval(()=>{
                    this.letTime+=5
                },5)
            },
            endPlaying(){
                if(this.playType == 'do'){
                    if(this.submitNum<=0) this.submitNum==-1? this.submitNum=-1:this.submitNum=0
                    else this.submitNum--;
                    this.playType = 'click'
                }else{
                     if(this.plays<=0) this.plays==-1? this.plays=-1:this.plays=0
                    else this.plays--;
                }
                clearInterval(this.timeHer)
                this.letTime = 0
            },
            getPlaysLuYing(){
                this.$refs.audioRef && this.$refs.audioRef.endAudio();
                this.$refs.audioRecording.fatherPlay(1000,-1);
            },
            startPlayingLuYing(){},
            endPlayingLuYing(){},
            yesNotProblem(){
                if(this.luYingUrl) return true
                return false
            },
            startAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                this.$refs.audioRef.goPlay()
                this.endPlaying()
            },
            endAudio(){
                if(!this.heart.questionDto.detailInfo.audioUrl) return
                if(!this.$refs.audioRef.judgePaying()){
                    this.endPlaying()
                }
                this.$refs.audioRef.endAudio()
                if(this.$refs.audioRecording) this.$refs.audioRecording.endAudio()
                if(this.recordingType == 'ing'){this.endRecording()}
            },
            // 打分
            getAjaxScore(url,callback){
                let that = this
                that.$axios.post('/alg/audio/similarity',{
                    firstUrl:that.heart.questionDto.detailInfo.audioUrl,
                    secondUrl:url,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                },res => {
                    var v = res.data
                    if (v.code == 0) {
                        that.score =utils.unsingNumber(((v.data.score/100)*that.heart.score),'floor',2)
                        that.detailJsonVal = JSON.stringify(v.data)
                    }
                    return callback()
                })
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        .zhiAudio{
            height: 33px;
            width: 100%;
            box-sizing: border-box;
            padding-left: 16px;
            .playNum{
                float: left;
                display: inline-block;
                height: 33px;
                width: 100px;
                .playNumIng{
                    display: inline-block;
                    img{
                        margin: 5px 0 0 15px;
                        vertical-align: text-bottom;
                    }
                }
            }
        }
        .explainText{
            box-sizing: border-box;
            padding:5px 0 0 16px;
            text-align: left;
            font-size: 12px;
            color: #A0A1A0;
        }
        .imgStyle{
            width: 100%;
            // height: 92%;
            height: 89%;
            box-sizing: border-box;
            padding: 25px 18px;
            background-image: url('../../../static/images/back-bg.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .quImg{
                width: 70%;
                height: 100%;
                display: inline-block;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                    display: table-cell;
                    vertical-align: middle;
                    align-items: center;
                    max-height: 98%;
                    max-width: 100%;
                }
                @media only screen and (min-height: 875px) {
                    img{
                        max-height: 94%;
                    }
                }
                @media only screen and (min-height: 990px) {
                    img{
                        max-height: 93%;
                    }
                }
            }
            .playTheDrums{
                width: 30%;
                height: 100%;
                position: relative;
                .operationBox{
                    position: absolute;
                    left: 28%;
                    right: 25%;
                    top: 47%;
                    height: 10%;
                    max-height: 45px;
                    min-height: 35px;
                }
                .operationGo{
                    height: 100%;
                    background-color: rgb(0, 204, 106);
                    color: #fff;
                    border: 3px solid rgb(207, 255, 232);
                    padding: 9px 20px;
                }
                .operationIng{
                    height: 100%;
                    background-color: rgb(204, 0, 0);
                    color: #fff;
                    border: 3px solid rgb(204, 0, 0);
                    padding: 9px 20px;
                }
                @media only screen and (max-height: 713px) {
                    .operationGo,
                    .operationIng{
                        padding: 6px 20px;
                    }
                    .operationBox{
                        top: 42%;
                    }
                }
                @media only screen and (max-height: 600px) {
                    .operationBox{
                        top: 30%;
                    }
                }
                .operationEnd{
                    width: 45%;
                    height: 33px;
                    background-color: rgb(59,131,252);
                    color: #fff;
                    border: 0px;
                    float: left;
                }
                p{
                    position: absolute;
                    top: 58%;
                    height:15px;
                    left: 0;
                    right: 0;
                    text-align: center;
                    font-size: 12px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/exam/rhythmScChoice.vue